/**
 * Canonical JSON-LD structured-data blobs for Winhouse Tutors.
 *
 * Used by `<Seo jsonLd={...} />` to emit schema.org markup that helps search
 * engines understand the business. Edit copy here — it ships everywhere.
 */

const SITE_URL = 'https://winhousetutors.academy';
const LOGO_URL = `${SITE_URL}/winhouse-logo-optimized-final.png`;

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Winhouse Tutors',
  url: SITE_URL,
  logo: LOGO_URL,
  description:
    'Premium online tutoring for IELTS, VCE, GMAT, GRE, SAT, PTE and Selective Entry. Expert coaching for better scores.',
  sameAs: [
    'https://www.instagram.com/winhouseconsultancy',
    'https://www.facebook.com/share/1EMEt5VjP5/',
    'https://www.linkedin.com/company/winhouse-consultancy/',
    'https://www.tiktok.com/@winhouse_consultancy',
  ],
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+61-493-305-420',
      contactType: 'customer service',
      email: 'info@winhousetutors.com',
      areaServed: ['AU', 'Worldwide'],
      availableLanguage: ['English'],
    },
  ],
};

export const LOCAL_BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  name: 'Winhouse Tutors',
  url: SITE_URL,
  logo: LOGO_URL,
  image: LOGO_URL,
  description:
    'Expert one-on-one tutoring across VCE, IELTS, Selective Entry, GMAT, GRE, SAT and PTE. Online and in-person.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Melbourne',
    addressRegion: 'VIC',
    addressCountry: 'AU',
  },
  areaServed: 'Worldwide',
  telephone: '+61-493-305-420',
  email: 'info@winhousetutors.com',
  priceRange: '$$',
};

export const EDUCATIONAL_SERVICE_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Tutoring',
  provider: {
    '@type': 'Organization',
    name: 'Winhouse Tutors',
    url: SITE_URL,
  },
  areaServed: 'Worldwide',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Tutoring Programs',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'VCE Tutoring' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'IELTS Coaching' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'Selective Entry Preparation' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'GMAT Preparation' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'GRE Preparation' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'SAT Preparation' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Course', name: 'PTE Coaching' } },
    ],
  },
};

// Combined graph used on the home page — gives Google a single connected
// business identity rather than three disconnected entries.
export const HOME_PAGE_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    ORGANIZATION_SCHEMA,
    LOCAL_BUSINESS_SCHEMA,
    EDUCATIONAL_SERVICE_SCHEMA,
  ],
};
